<section class>
    <section class="mydocuments">

        <!-- <div role="presentation" class="active" style="background-color: yellow;"><a data-toggle="tab" href="#transactions">Transaction History</a></div>
      <div role="presentation"><a data-toggle="tab" href="#certificates">Certificates</a></div>
      <div role="presentation"><a data-toggle="tab" href="#documents">Documents</a></div> -->
        <div class="degdlg-component">
            <div class="degdlg-tabbed">
                <ul
                    role="tablist"
                    class="degdlg-tab-list"
                >
                    <!-- add class degdlg-tab--is-selected when ready to enable other tabs -->
                    <li
                        role="presentation"
                        class="degdlg-tab"
                        [ngClass]="{'degdlg-tab--is-selected': tabselector === 'tabs1'}"
                    >
                        <a
                            role="tab"
                            id="tabs-cert"
                            class="degdlg-tab__link"
                            (click)="tabClick('tabs1')"
                        >
                            Certificates
                        </a>
                    </li>

                    <li
                        role="presentation"
                        class="degdlg-tab"
                        [ngClass]="{'degdlg-tab--is-selected': tabselector === 'tabs0'}"
                    >
                        <a
                            role="tab"
                            id="tabs-rec"
                            class="degdlg-tab__link"
                            (click)="tabClick('tabs0')"
                        >
                            Receipts
                        </a>
                    </li>
                    <!-- Uncomment below when ready to enable the other tabs -->
                    <!-- <li *ngIf="tabselector=='tabs2'; else notTabs2" role="presentation" class="degdlg-tab degdlg-tab--is-selected"><a role="tab" id="tabs-2" class="degdlg-tab__link" (click)="tabClick('tabs2');">Documents</a></li>
            <ng-template #notTabs2>
            <li role="presentation" class="degdlg-tab"><a role="tab" id="tabs-2" class="degdlg-tab__link" (click)="tabClick('tabs2');">Documents</a></li>
            </ng-template> -->
                </ul>
            </div>
        </div>
        <section
            id="tabs-purchasehistory"
            class="degdlg-tab-panel"
            role="tabpanel"
            tabindex="-1"
        >
            <div
                class="tab-content"
                *ngIf="tabselector === 'tabs0'"
            >
                <app-purchase-history
                    id="transactions"
                    class="tab-pane fade in active"
                ></app-purchase-history>
            </div>
        </section>
        <section
            id="tabs-certificates"
            class="degdlg-tab-panel"
            role="tabpanel"
            tabindex="-1"
        >
            <div
                class="tab-content"
                *ngIf="tabselector === 'tabs1'"
            >
                <app-certificates-view
                    id="certificatesView"
                    class="tab-pane fade in active"
                ></app-certificates-view>
            </div>
        </section>
        <section
            id="tabs-mydocuments"
            class="degdlg-tab-panel"
            role="tabpanel"
            tabindex="-1"
        >
            <div
                class="tab-content"
                *ngIf="tabselector === 'tabs2'"
            >
                <p>Coming Soon</p>
            </div>
        </section>
    </section>
</section>
